function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import queryString from 'query-string';
export function context() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    context: []
  };
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case 'SET_CONTEXT':
      {
        const stateContext = state.context;
        const queryUrl = queryString.parse(action.queryUrl);
        const stateContextFiltered = [...stateContext.filter(st => Object.keys(queryUrl).includes(st.id))];
        const newContext = [...stateContextFiltered.filter(cont => cont.id !== action.id), {
          id: action.id,
          model: _objectSpread({}, action.model)
        }];
        return _objectSpread(_objectSpread({}, state), {
          context: newContext
        });
      }
    case 'CLEAR_CONTEXT':
      {
        return _objectSpread(_objectSpread({}, state), {
          context: []
        });
      }
    default:
      return state;
  }
}